import { render, staticRenderFns } from "./TenderDetails.vue?vue&type=template&id=2b694c68&"
import script from "./TenderDetails.vue?vue&type=script&lang=js&"
export * from "./TenderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports